//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class AccountManagementClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    createAccount(createAccountRequest: CreateAccountRequest): Promise<CreateAccountResponse> {
        let url_ = this.baseUrl + "/api/account-management/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAccountRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "*/*",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: Response): Promise<CreateAccountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAccountResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MicrosoftAspNetCoreMvcProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateAccountResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAccountResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAccountOnboardingStage(): Promise<PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse> {
        let url_ = this.baseUrl + "/api/account-management/accounts/onboarding/stage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountOnboardingStage(_response);
        });
    }

    protected processGetAccountOnboardingStage(response: Response): Promise<PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = MicrosoftAspNetCoreMvcProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = MicrosoftAspNetCoreMvcProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse>(null as any);
    }

    /**
     * Add an Account Holder (without any details)
     * @return Success
     */
    addAccountHolder(request: AddAccountHolder_Request): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/account-holder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccountHolder(_response);
        });
    }

    protected processAddAccountHolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get account holder details for the currently logged in User
     * @return Success
     */
    getAccountHolder(): Promise<GetAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountHolder(_response);
        });
    }

    protected processGetAccountHolder(response: Response): Promise<GetAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountHolder_Response_Root>(null as any);
    }

    /**
     * Add an account to an account holder
     * @return Success
     */
    addAccountToAccountHolder(root: AddAccountToAccountHolder_Request_Root, accountHolderId: string): Promise<AddAccountToAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/account";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccountToAccountHolder(_response);
        });
    }

    protected processAddAccountToAccountHolder(response: Response): Promise<AddAccountToAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAccountToAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddAccountToAccountHolder_Response_Root>(null as any);
    }

    /**
     * Add a bank account to an account holder
     * @return Success
     */
    addBankDetailsToAccountHolder(request: AddBankDetailsToAccountHolder_Request, accountHolderId: string): Promise<AddBankDetailsToAccountHolder_Response> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/bank-account";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddBankDetailsToAccountHolder(_response);
        });
    }

    protected processAddBankDetailsToAccountHolder(response: Response): Promise<AddBankDetailsToAccountHolder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddBankDetailsToAccountHolder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddBankDetailsToAccountHolder_Response>(null as any);
    }

    /**
     * Create a Junior ISA account with an adult registered contact and child beneficiary
     * @return Success
     */
    addJisaAccountToAccountHolders(root: AddJisaAccountToAccountHolders_Request_Root): Promise<AddJisaAccountToAccountHolders_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/jisa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddJisaAccountToAccountHolders(_response);
        });
    }

    protected processAddJisaAccountToAccountHolders(response: Response): Promise<AddJisaAccountToAccountHolders_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddJisaAccountToAccountHolders_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddJisaAccountToAccountHolders_Response_Root>(null as any);
    }

    /**
     * Confirm an account image upload
     * @return No Content
     */
    confirmAccountImageUpload(request: ConfirmAccountImageUpload_Request, accountId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/account/{accountId}/image/confirm";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "*/*",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmAccountImageUpload(_response);
        });
    }

    protected processConfirmAccountImageUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the account image
     * @return No Content
     */
    deleteAccountImage(accountId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/account/{accountId}/image";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAccountImage(_response);
        });
    }

    protected processDeleteAccountImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Generate a signed upload URL for an account image
     * @return Success
     */
    generateAccountImageUploadUrl(request: GenerateAccountImageUploadUrl_Request, accountId: string): Promise<GenerateAccountImageUploadUrl_Response> {
        let url_ = this.baseUrl + "/api/account-management/account/{accountId}/image/upload-url";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "*/*",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateAccountImageUploadUrl(_response);
        });
    }

    protected processGenerateAccountImageUploadUrl(response: Response): Promise<GenerateAccountImageUploadUrl_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateAccountImageUploadUrl_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateAccountImageUploadUrl_Response>(null as any);
    }

    /**
     * Get the specified account
     * @return Success
     */
    getAccount(accountId: string): Promise<GetAccount_Response> {
        let url_ = this.baseUrl + "/api/account-management/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccount(_response);
        });
    }

    protected processGetAccount(response: Response): Promise<GetAccount_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccount_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccount_Response>(null as any);
    }

    /**
     * Get all account holder details for the currently logged in User, ordered by adult first then child
     * @return Success
     */
    getAccountHolders(): Promise<GetAccountHolders_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountHolders(_response);
        });
    }

    protected processGetAccountHolders(response: Response): Promise<GetAccountHolders_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountHolders_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountHolders_Response_Root>(null as any);
    }

    /**
     * Get all accounts for an account holder
     * @return Success
     */
    getAccountsByAccountHolder(accountHolderId: string): Promise<GetAccountsByAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/accounts";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountsByAccountHolder(_response);
        });
    }

    protected processGetAccountsByAccountHolder(response: Response): Promise<GetAccountsByAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountsByAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountsByAccountHolder_Response_Root>(null as any);
    }

    /**
     * Get the investment account onboarding stage for a mobile app user
     * @return Success
     */
    getInvestmentAccountOnboardingStage(): Promise<GetInvestmentAccountOnboardingStage_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/investment-onboarding/stage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInvestmentAccountOnboardingStage(_response);
        });
    }

    protected processGetInvestmentAccountOnboardingStage(response: Response): Promise<GetInvestmentAccountOnboardingStage_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestmentAccountOnboardingStage_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInvestmentAccountOnboardingStage_Response_Root>(null as any);
    }

    /**
     * Get the bank details for the Investment Provider
     * @return Success
     */
    getInvestmentProviderBankDetails(): Promise<GetInvestmentProviderBankDetails_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/provider-bank-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInvestmentProviderBankDetails(_response);
        });
    }

    protected processGetInvestmentProviderBankDetails(response: Response): Promise<GetInvestmentProviderBankDetails_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvestmentProviderBankDetails_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInvestmentProviderBankDetails_Response_Root>(null as any);
    }

    /**
     * Get the JISA account onboarding stage
     * @return Success
     */
    getJisaAccountOnboardingStage(accountId: string): Promise<GetJisaAccountOnboardingStage_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/jisa/{accountId}/onboarding/stage";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJisaAccountOnboardingStage(_response);
        });
    }

    protected processGetJisaAccountOnboardingStage(response: Response): Promise<GetJisaAccountOnboardingStage_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJisaAccountOnboardingStage_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJisaAccountOnboardingStage_Response_Root>(null as any);
    }

    /**
     * Get the current onboarding stage for the user
     * @return Success
     */
    getOnboardingStage(): Promise<GetOnboardingStage_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/onboarding/stage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOnboardingStage(_response);
        });
    }

    protected processGetOnboardingStage(response: Response): Promise<GetOnboardingStage_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnboardingStage_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOnboardingStage_Response_Root>(null as any);
    }

    /**
     * Get the onboarding flag for a mobile app user
     * @return Success
     */
    getOnboardingStageV2(): Promise<GetOnboardingStageV2_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/onboarding/stage/v2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOnboardingStageV2(_response);
        });
    }

    protected processGetOnboardingStageV2(response: Response): Promise<GetOnboardingStageV2_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnboardingStageV2_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOnboardingStageV2_Response_Root>(null as any);
    }

    /**
     * Get all openable accounts for the current user
     * @return Success
     */
    getOpenableAccountsForAccountHolder(accountHolderId: string): Promise<GetOpenableAccountsForAccountHolder_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}/accounts/openable";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOpenableAccountsForAccountHolder(_response);
        });
    }

    protected processGetOpenableAccountsForAccountHolder(response: Response): Promise<GetOpenableAccountsForAccountHolder_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOpenableAccountsForAccountHolder_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOpenableAccountsForAccountHolder_Response_Root>(null as any);
    }

    /**
     * @return Success
     */
    getWealthKernelAccountSyncingHealth(userId: string): Promise<GetWealthKernelAccountSyncingHealth_Response> {
        let url_ = this.baseUrl + "/api/account-management/{userId}/account-syncing-health";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWealthKernelAccountSyncingHealth(_response);
        });
    }

    protected processGetWealthKernelAccountSyncingHealth(response: Response): Promise<GetWealthKernelAccountSyncingHealth_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWealthKernelAccountSyncingHealth_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWealthKernelAccountSyncingHealth_Response>(null as any);
    }

    /**
     * Make a declaration for the specified account
     * @return No Content
     */
    makeDeclaration(accountGlobalId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/accounts/{accountGlobalId}/make-declaration";
        if (accountGlobalId === undefined || accountGlobalId === null)
            throw new Error("The parameter 'accountGlobalId' must be defined.");
        url_ = url_.replace("{accountGlobalId}", encodeURIComponent("" + accountGlobalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMakeDeclaration(_response);
        });
    }

    protected processMakeDeclaration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Make a declaration for the specified JISA account
     * @return The declaration was successfully created
     */
    makeJisaDeclaration(accountGlobalId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/accounts/{accountGlobalId}/make-jisa-declaration";
        if (accountGlobalId === undefined || accountGlobalId === null)
            throw new Error("The parameter 'accountGlobalId' must be defined.");
        url_ = url_.replace("{accountGlobalId}", encodeURIComponent("" + accountGlobalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMakeJisaDeclaration(_response);
        });
    }

    protected processMakeJisaDeclaration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set the onboarding completion status for a user
     * @return No Content
     */
    setUserOnboarding(root: SetUserOnboarding_Request_Root): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserOnboarding(_response);
        });
    }

    protected processSetUserOnboarding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update account holder (and address)
     * @return No Content
     */
    updateAccountHolder(root: UpdateAccountHolder_Request_Root, accountHolderId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/account-holder/{accountHolderId}";
        if (accountHolderId === undefined || accountHolderId === null)
            throw new Error("The parameter 'accountHolderId' must be defined.");
        url_ = url_.replace("{accountHolderId}", encodeURIComponent("" + accountHolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAccountHolder(_response);
        });
    }

    protected processUpdateAccountHolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Pings the account management service to avoid long cold starts
     * @return No Content
     */
    warmup(): Promise<void> {
        let url_ = this.baseUrl + "/api/account-management/warmup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarmup(_response);
        });
    }

    protected processWarmup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Exchange a Plaid Auth public token for an access token
     * @return Success
     */
    plaidExchangePlaidAuthPublicToken(request: PlaidExchangePlaidAuthPublicToken_Request): Promise<PlaidExchangePlaidAuthPublicToken_Response> {
        let url_ = this.baseUrl + "/api/account-management/plaid/exchange-auth-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPlaidExchangePlaidAuthPublicToken(_response);
        });
    }

    protected processPlaidExchangePlaidAuthPublicToken(response: Response): Promise<PlaidExchangePlaidAuthPublicToken_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaidExchangePlaidAuthPublicToken_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaidExchangePlaidAuthPublicToken_Response>(null as any);
    }

    /**
     * Get a Plaid link token
     * @return Success
     */
    plaidGetPlaidAuthLinkToken(devicePlatform: string, redirectUri: string): Promise<PlaidGetPlaidAuthLinkToken_Response> {
        let url_ = this.baseUrl + "/api/account-management/plaid/auth-link-token?";
        if (devicePlatform === undefined || devicePlatform === null)
            throw new Error("The parameter 'devicePlatform' must be defined and cannot be null.");
        else
            url_ += "devicePlatform=" + encodeURIComponent("" + devicePlatform) + "&";
        if (redirectUri === undefined || redirectUri === null)
            throw new Error("The parameter 'redirectUri' must be defined and cannot be null.");
        else
            url_ += "redirectUri=" + encodeURIComponent("" + redirectUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPlaidGetPlaidAuthLinkToken(_response);
        });
    }

    protected processPlaidGetPlaidAuthLinkToken(response: Response): Promise<PlaidGetPlaidAuthLinkToken_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaidGetPlaidAuthLinkToken_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaidGetPlaidAuthLinkToken_Response>(null as any);
    }

    /**
     * Check if the user has valid Plaid credentials
     * @return Success
     */
    plaidVerifyPlaidLinkStatus(): Promise<PlaidVerifyPlaidLinkStatus_Response> {
        let url_ = this.baseUrl + "/api/account-management/plaid/link-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPlaidVerifyPlaidLinkStatus(_response);
        });
    }

    protected processPlaidVerifyPlaidLinkStatus(response: Response): Promise<PlaidVerifyPlaidLinkStatus_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaidVerifyPlaidLinkStatus_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaidVerifyPlaidLinkStatus_Response>(null as any);
    }

    /**
     * Inform client whether an update is required
     * @return Success
     */
    mobileGetAppUpdateRequired(platform: MobileGetAppUpdateRequired_Request_Platform, major: number, minor: number, patch: number): Promise<MobileGetAppUpdateRequired_Response_Root> {
        let url_ = this.baseUrl + "/api/account-management/mobile/app-update-required/{platform}/{major}/{minor}/{patch}";
        if (platform === undefined || platform === null)
            throw new Error("The parameter 'platform' must be defined.");
        url_ = url_.replace("{platform}", encodeURIComponent("" + platform));
        if (major === undefined || major === null)
            throw new Error("The parameter 'major' must be defined.");
        url_ = url_.replace("{major}", encodeURIComponent("" + major));
        if (minor === undefined || minor === null)
            throw new Error("The parameter 'minor' must be defined.");
        url_ = url_.replace("{minor}", encodeURIComponent("" + minor));
        if (patch === undefined || patch === null)
            throw new Error("The parameter 'patch' must be defined.");
        url_ = url_.replace("{patch}", encodeURIComponent("" + patch));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMobileGetAppUpdateRequired(_response);
        });
    }

    protected processMobileGetAppUpdateRequired(response: Response): Promise<MobileGetAppUpdateRequired_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileGetAppUpdateRequired_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MobileGetAppUpdateRequired_Response_Root>(null as any);
    }
}

export class CreateAccountResponse implements ICreateAccountResponse {
    accountId?: string;

    constructor(data?: ICreateAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): CreateAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface ICreateAccountResponse {
    accountId?: string;
}

export class MicrosoftAspNetCoreMvcProblemDetails implements IMicrosoftAspNetCoreMvcProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IMicrosoftAspNetCoreMvcProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): MicrosoftAspNetCoreMvcProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftAspNetCoreMvcProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IMicrosoftAspNetCoreMvcProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class CreateAccountRequest implements ICreateAccountRequest {
    accountType!: AccountType;
    accountHolderId!: string;
    beneficiaryAccountHolderId?: string | undefined;

    constructor(data?: ICreateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
            this.accountHolderId = _data["accountHolderId"];
            this.beneficiaryAccountHolderId = _data["beneficiaryAccountHolderId"];
        }
    }

    static fromJS(data: any): CreateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        data["accountHolderId"] = this.accountHolderId;
        data["beneficiaryAccountHolderId"] = this.beneficiaryAccountHolderId;
        return data;
    }
}

export interface ICreateAccountRequest {
    accountType: AccountType;
    accountHolderId: string;
    beneficiaryAccountHolderId?: string | undefined;
}

export enum AccountType {
    Isa = "Isa",
    Gia = "Gia",
    Jisa = "Jisa",
}

export class PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse implements IPropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse {
    stage?: PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStage;
    accountType?: PropelleAccountManagementCoreApplicationDomainAccountType;
    accountId?: string;
    lastUpdated?: Date;
    holders?: PropelleAccountManagementCoreApplicationEnumsAccountHolderProgress[];

    constructor(data?: IPropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
            this.accountType = _data["accountType"];
            this.accountId = _data["accountId"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            if (Array.isArray(_data["holders"])) {
                this.holders = [] as any;
                for (let item of _data["holders"])
                    this.holders!.push(PropelleAccountManagementCoreApplicationEnumsAccountHolderProgress.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["accountType"] = this.accountType;
        data["accountId"] = this.accountId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        if (Array.isArray(this.holders)) {
            data["holders"] = [];
            for (let item of this.holders)
                data["holders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropelleAccountManagementCoreApplicationEnumsAccountOnboardingStageResponse {
    stage?: PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStage;
    accountType?: PropelleAccountManagementCoreApplicationDomainAccountType;
    accountId?: string;
    lastUpdated?: Date;
    holders?: PropelleAccountManagementCoreApplicationEnumsAccountHolderProgress[];
}

export enum PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStage {
    NotStarted = "NotStarted",
    IsaPersonalDetails = "IsaPersonalDetails",
    IsaDeclaration = "IsaDeclaration",
    IsaKycProcessing = "IsaKycProcessing",
    IsaBankDetails = "IsaBankDetails",
    IsaComplete = "IsaComplete",
    GiaPersonalDetails = "GiaPersonalDetails",
    GiaKycProcessing = "GiaKycProcessing",
    GiaBankDetails = "GiaBankDetails",
    GiaComplete = "GiaComplete",
    JisaRegisteredContactDetails = "JisaRegisteredContactDetails",
    JisaRegisteredContactKyc = "JisaRegisteredContactKyc",
    JisaBeneficiaryDetails = "JisaBeneficiaryDetails",
    JisaDeclaration = "JisaDeclaration",
    JisaComplete = "JisaComplete",
}

export enum PropelleAccountManagementCoreApplicationDomainAccountType {
    Isa = "Isa",
    Gia = "Gia",
    Jisa = "Jisa",
}

export class PropelleAccountManagementCoreApplicationEnumsAccountHolderProgress implements IPropelleAccountManagementCoreApplicationEnumsAccountHolderProgress {
    accountHolderId?: string;
    role?: PropelleAccountManagementCoreApplicationDomainOwnershipRole;
    hasAddress?: boolean;
    isSubmitted?: boolean;
    submittedId?: string | undefined;
    holderType?: PropelleAccountManagementCoreApplicationDomainAccountHolderType;

    constructor(data?: IPropelleAccountManagementCoreApplicationEnumsAccountHolderProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderId = _data["accountHolderId"];
            this.role = _data["role"];
            this.hasAddress = _data["hasAddress"];
            this.isSubmitted = _data["isSubmitted"];
            this.submittedId = _data["submittedId"];
            this.holderType = _data["holderType"];
        }
    }

    static fromJS(data: any): PropelleAccountManagementCoreApplicationEnumsAccountHolderProgress {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleAccountManagementCoreApplicationEnumsAccountHolderProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderId"] = this.accountHolderId;
        data["role"] = this.role;
        data["hasAddress"] = this.hasAddress;
        data["isSubmitted"] = this.isSubmitted;
        data["submittedId"] = this.submittedId;
        data["holderType"] = this.holderType;
        return data;
    }
}

export interface IPropelleAccountManagementCoreApplicationEnumsAccountHolderProgress {
    accountHolderId?: string;
    role?: PropelleAccountManagementCoreApplicationDomainOwnershipRole;
    hasAddress?: boolean;
    isSubmitted?: boolean;
    submittedId?: string | undefined;
    holderType?: PropelleAccountManagementCoreApplicationDomainAccountHolderType;
}

export enum PropelleAccountManagementCoreApplicationDomainOwnershipRole {
    Owner = "Owner",
    RegisteredContact = "RegisteredContact",
    Beneficiary = "Beneficiary",
}

export enum PropelleAccountManagementCoreApplicationDomainAccountHolderType {
    Adult = "Adult",
    Child = "Child",
}

export class AddAccountHolder_Request implements IAddAccountHolder_Request {
    accountHolderType?: PropelleAccountManagementCoreApplicationDomainAccountHolderType | undefined;

    constructor(data?: IAddAccountHolder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderType = _data["accountHolderType"];
        }
    }

    static fromJS(data: any): AddAccountHolder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountHolder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderType"] = this.accountHolderType;
        return data;
    }
}

export interface IAddAccountHolder_Request {
    accountHolderType?: PropelleAccountManagementCoreApplicationDomainAccountHolderType | undefined;
}

export class AddAccountToAccountHolder_Response_Root implements IAddAccountToAccountHolder_Response_Root {
    accountId?: string;

    constructor(data?: IAddAccountToAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): AddAccountToAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountToAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IAddAccountToAccountHolder_Response_Root {
    accountId?: string;
}

/** the dto used to send an error response to the client */
export class FastEndpointsErrorResponse implements IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IFastEndpointsErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusCode = 400;
            this.message = "One or more errors occurred!";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : 400;
            this.message = _data["message"] !== undefined ? _data["message"] : "One or more errors occurred!";
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): FastEndpointsErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FastEndpointsErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

export class AddAccountToAccountHolder_Request_Root implements IAddAccountToAccountHolder_Request_Root {
    accountType?: AccountType;

    constructor(data?: IAddAccountToAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): AddAccountToAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountToAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IAddAccountToAccountHolder_Request_Root {
    accountType?: AccountType;
}

export class AddBankDetailsToAccountHolder_Response implements IAddBankDetailsToAccountHolder_Response {
    bankAccountId?: string;

    constructor(data?: IAddBankDetailsToAccountHolder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAccountId = _data["bankAccountId"];
        }
    }

    static fromJS(data: any): AddBankDetailsToAccountHolder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AddBankDetailsToAccountHolder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccountId"] = this.bankAccountId;
        return data;
    }
}

export interface IAddBankDetailsToAccountHolder_Response {
    bankAccountId?: string;
}

export class AddBankDetailsToAccountHolder_Request implements IAddBankDetailsToAccountHolder_Request {
    accountName!: string;
    sortCode!: string;
    accountNumber!: string;

    constructor(data?: IAddBankDetailsToAccountHolder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.sortCode = _data["sortCode"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): AddBankDetailsToAccountHolder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AddBankDetailsToAccountHolder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["sortCode"] = this.sortCode;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IAddBankDetailsToAccountHolder_Request {
    accountName: string;
    sortCode: string;
    accountNumber: string;
}

export class AddJisaAccountToAccountHolders_Response_Root implements IAddJisaAccountToAccountHolders_Response_Root {
    accountId?: string;

    constructor(data?: IAddJisaAccountToAccountHolders_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): AddJisaAccountToAccountHolders_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddJisaAccountToAccountHolders_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IAddJisaAccountToAccountHolders_Response_Root {
    accountId?: string;
}

export class AddJisaAccountToAccountHolders_Request_Root implements IAddJisaAccountToAccountHolders_Request_Root {
    adultAccountHolderId!: string;
    childAccountHolderId!: string;

    constructor(data?: IAddJisaAccountToAccountHolders_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adultAccountHolderId = _data["adultAccountHolderId"];
            this.childAccountHolderId = _data["childAccountHolderId"];
        }
    }

    static fromJS(data: any): AddJisaAccountToAccountHolders_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new AddJisaAccountToAccountHolders_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adultAccountHolderId"] = this.adultAccountHolderId;
        data["childAccountHolderId"] = this.childAccountHolderId;
        return data;
    }
}

export interface IAddJisaAccountToAccountHolders_Request_Root {
    adultAccountHolderId: string;
    childAccountHolderId: string;
}

export class ConfirmAccountImageUpload_Request implements IConfirmAccountImageUpload_Request {
    objectName!: string;

    constructor(data?: IConfirmAccountImageUpload_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): ConfirmAccountImageUpload_Request {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAccountImageUpload_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface IConfirmAccountImageUpload_Request {
    objectName: string;
}

export class DeleteAccountImage_Request implements IDeleteAccountImage_Request {

    constructor(data?: IDeleteAccountImage_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteAccountImage_Request {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountImage_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteAccountImage_Request {
}

export class GenerateAccountImageUploadUrl_Response implements IGenerateAccountImageUploadUrl_Response {
    uploadUrl?: string;
    objectName?: string;
    expiresAt?: Date;

    constructor(data?: IGenerateAccountImageUploadUrl_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadUrl = _data["uploadUrl"];
            this.objectName = _data["objectName"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateAccountImageUploadUrl_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAccountImageUploadUrl_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadUrl"] = this.uploadUrl;
        data["objectName"] = this.objectName;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGenerateAccountImageUploadUrl_Response {
    uploadUrl?: string;
    objectName?: string;
    expiresAt?: Date;
}

export class GenerateAccountImageUploadUrl_Request implements IGenerateAccountImageUploadUrl_Request {
    contentType!: string;

    constructor(data?: IGenerateAccountImageUploadUrl_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GenerateAccountImageUploadUrl_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAccountImageUploadUrl_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGenerateAccountImageUploadUrl_Request {
    contentType: string;
}

export class GetAccount_Response implements IGetAccount_Response {
    accountType?: AccountType;
    status?: AccountStatus | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IGetAccount_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
            this.status = _data["status"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): GetAccount_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccount_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        data["status"] = this.status;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IGetAccount_Response {
    accountType?: AccountType;
    status?: AccountStatus | undefined;
    imageUrl?: string | undefined;
}

export enum AccountStatus {
    Active = "Active",
    TradingAllowed = "TradingAllowed",
}

export class GetAccount_Request implements IGetAccount_Request {

    constructor(data?: IGetAccount_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAccount_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccount_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAccount_Request {
}

export class GetAccountHolder_Response_Root implements IGetAccountHolder_Response_Root {
    accountHolderId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nino?: string | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
    canUpdate?: boolean;
    currentAddress?: GetAccountHolder_Response_AddressModel | undefined;
    currentBankDetails?: GetAccountHolder_Response_BankDetailsModel | undefined;
    holderType?: string | undefined;
    rowVersion?: number;

    constructor(data?: IGetAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderId = _data["accountHolderId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.isUkTaxResident = _data["isUkTaxResident"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.nino = _data["nino"];
            this.nationality = _data["nationality"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.employmentStatus = _data["employmentStatus"];
            this.industry = _data["industry"];
            if (Array.isArray(_data["sourcesOfWealth"])) {
                this.sourcesOfWealth = [] as any;
                for (let item of _data["sourcesOfWealth"])
                    this.sourcesOfWealth!.push(item);
            }
            this.annualIncome = _data["annualIncome"];
            this.canUpdate = _data["canUpdate"];
            this.currentAddress = _data["currentAddress"] ? GetAccountHolder_Response_AddressModel.fromJS(_data["currentAddress"]) : <any>undefined;
            this.currentBankDetails = _data["currentBankDetails"] ? GetAccountHolder_Response_BankDetailsModel.fromJS(_data["currentBankDetails"]) : <any>undefined;
            this.holderType = _data["holderType"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderId"] = this.accountHolderId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["isUkTaxResident"] = this.isUkTaxResident;
        data["isUsCitizen"] = this.isUsCitizen;
        data["nino"] = this.nino;
        data["nationality"] = this.nationality;
        data["countryOfBirth"] = this.countryOfBirth;
        data["employmentStatus"] = this.employmentStatus;
        data["industry"] = this.industry;
        if (Array.isArray(this.sourcesOfWealth)) {
            data["sourcesOfWealth"] = [];
            for (let item of this.sourcesOfWealth)
                data["sourcesOfWealth"].push(item);
        }
        data["annualIncome"] = this.annualIncome;
        data["canUpdate"] = this.canUpdate;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["currentBankDetails"] = this.currentBankDetails ? this.currentBankDetails.toJSON() : <any>undefined;
        data["holderType"] = this.holderType;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetAccountHolder_Response_Root {
    accountHolderId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nino?: string | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
    canUpdate?: boolean;
    currentAddress?: GetAccountHolder_Response_AddressModel | undefined;
    currentBankDetails?: GetAccountHolder_Response_BankDetailsModel | undefined;
    holderType?: string | undefined;
    rowVersion?: number;
}

export class GetAccountHolder_Response_AddressModel implements IGetAccountHolder_Response_AddressModel {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
    rowVersion?: number;

    constructor(data?: IGetAccountHolder_Response_AddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.line3 = _data["line3"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.countryCode = _data["countryCode"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetAccountHolder_Response_AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolder_Response_AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["line3"] = this.line3;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["countryCode"] = this.countryCode;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetAccountHolder_Response_AddressModel {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
    rowVersion?: number;
}

export class GetAccountHolder_Response_BankDetailsModel implements IGetAccountHolder_Response_BankDetailsModel {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;

    constructor(data?: IGetAccountHolder_Response_BankDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): GetAccountHolder_Response_BankDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolder_Response_BankDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["sortCode"] = this.sortCode;
        return data;
    }
}

export interface IGetAccountHolder_Response_BankDetailsModel {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;
}

export class GetAccountHolders_Response_Root implements IGetAccountHolders_Response_Root {
    accountHolders?: GetAccountHolders_Response_AccountHolderModel[] | undefined;

    constructor(data?: IGetAccountHolders_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountHolders"])) {
                this.accountHolders = [] as any;
                for (let item of _data["accountHolders"])
                    this.accountHolders!.push(GetAccountHolders_Response_AccountHolderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAccountHolders_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolders_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountHolders)) {
            data["accountHolders"] = [];
            for (let item of this.accountHolders)
                data["accountHolders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAccountHolders_Response_Root {
    accountHolders?: GetAccountHolders_Response_AccountHolderModel[] | undefined;
}

export class GetAccountHolders_Response_AccountHolderModel implements IGetAccountHolders_Response_AccountHolderModel {
    accountHolderId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nino?: string | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
    canUpdate?: boolean;
    currentAddress?: GetAccountHolders_Response_AddressModel | undefined;
    currentBankDetails?: GetAccountHolders_Response_BankDetailsModel | undefined;
    holderType?: string | undefined;
    rowVersion?: number;

    constructor(data?: IGetAccountHolders_Response_AccountHolderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderId = _data["accountHolderId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.isUkTaxResident = _data["isUkTaxResident"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.nino = _data["nino"];
            this.nationality = _data["nationality"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.employmentStatus = _data["employmentStatus"];
            this.industry = _data["industry"];
            if (Array.isArray(_data["sourcesOfWealth"])) {
                this.sourcesOfWealth = [] as any;
                for (let item of _data["sourcesOfWealth"])
                    this.sourcesOfWealth!.push(item);
            }
            this.annualIncome = _data["annualIncome"];
            this.canUpdate = _data["canUpdate"];
            this.currentAddress = _data["currentAddress"] ? GetAccountHolders_Response_AddressModel.fromJS(_data["currentAddress"]) : <any>undefined;
            this.currentBankDetails = _data["currentBankDetails"] ? GetAccountHolders_Response_BankDetailsModel.fromJS(_data["currentBankDetails"]) : <any>undefined;
            this.holderType = _data["holderType"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetAccountHolders_Response_AccountHolderModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolders_Response_AccountHolderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderId"] = this.accountHolderId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["isUkTaxResident"] = this.isUkTaxResident;
        data["isUsCitizen"] = this.isUsCitizen;
        data["nino"] = this.nino;
        data["nationality"] = this.nationality;
        data["countryOfBirth"] = this.countryOfBirth;
        data["employmentStatus"] = this.employmentStatus;
        data["industry"] = this.industry;
        if (Array.isArray(this.sourcesOfWealth)) {
            data["sourcesOfWealth"] = [];
            for (let item of this.sourcesOfWealth)
                data["sourcesOfWealth"].push(item);
        }
        data["annualIncome"] = this.annualIncome;
        data["canUpdate"] = this.canUpdate;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["currentBankDetails"] = this.currentBankDetails ? this.currentBankDetails.toJSON() : <any>undefined;
        data["holderType"] = this.holderType;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetAccountHolders_Response_AccountHolderModel {
    accountHolderId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nino?: string | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
    canUpdate?: boolean;
    currentAddress?: GetAccountHolders_Response_AddressModel | undefined;
    currentBankDetails?: GetAccountHolders_Response_BankDetailsModel | undefined;
    holderType?: string | undefined;
    rowVersion?: number;
}

export class GetAccountHolders_Response_AddressModel implements IGetAccountHolders_Response_AddressModel {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
    rowVersion?: number;

    constructor(data?: IGetAccountHolders_Response_AddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.line3 = _data["line3"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.countryCode = _data["countryCode"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetAccountHolders_Response_AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolders_Response_AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["line3"] = this.line3;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["countryCode"] = this.countryCode;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetAccountHolders_Response_AddressModel {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
    rowVersion?: number;
}

export class GetAccountHolders_Response_BankDetailsModel implements IGetAccountHolders_Response_BankDetailsModel {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;

    constructor(data?: IGetAccountHolders_Response_BankDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): GetAccountHolders_Response_BankDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountHolders_Response_BankDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["sortCode"] = this.sortCode;
        return data;
    }
}

export interface IGetAccountHolders_Response_BankDetailsModel {
    accountName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;
}

export class GetAccountsByAccountHolder_Response_Root implements IGetAccountsByAccountHolder_Response_Root {
    accounts?: GetAccountsByAccountHolder_Response_Account[];

    constructor(data?: IGetAccountsByAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(GetAccountsByAccountHolder_Response_Account.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAccountsByAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountsByAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAccountsByAccountHolder_Response_Root {
    accounts?: GetAccountsByAccountHolder_Response_Account[];
}

export class GetAccountsByAccountHolder_Response_Account implements IGetAccountsByAccountHolder_Response_Account {
    id?: string;
    accountType?: AccountType;

    constructor(data?: IGetAccountsByAccountHolder_Response_Account) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): GetAccountsByAccountHolder_Response_Account {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountsByAccountHolder_Response_Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IGetAccountsByAccountHolder_Response_Account {
    id?: string;
    accountType?: AccountType;
}

export class GetAccountsByAccountHolder_Request_Root implements IGetAccountsByAccountHolder_Request_Root {

    constructor(data?: IGetAccountsByAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAccountsByAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountsByAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAccountsByAccountHolder_Request_Root {
}

export class GetInvestmentAccountOnboardingStage_Response_Root implements IGetInvestmentAccountOnboardingStage_Response_Root {
    stage?: PropelleAccountManagementCoreApplicationEnumsOnboardingStage;

    constructor(data?: IGetInvestmentAccountOnboardingStage_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): GetInvestmentAccountOnboardingStage_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestmentAccountOnboardingStage_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        return data;
    }
}

export interface IGetInvestmentAccountOnboardingStage_Response_Root {
    stage?: PropelleAccountManagementCoreApplicationEnumsOnboardingStage;
}

export enum PropelleAccountManagementCoreApplicationEnumsOnboardingStage {
    NotStarted = "NotStarted",
    PersonalDetails = "PersonalDetails",
    Declaration = "Declaration",
    KYCChecks = "KYCChecks",
    BankDetails = "BankDetails",
    Complete = "Complete",
}

export class GetInvestmentProviderBankDetails_Response_Root implements IGetInvestmentProviderBankDetails_Response_Root {
    providerBankDetails?: GetInvestmentProviderBankDetails_Response_BankDetailsModel | undefined;

    constructor(data?: IGetInvestmentProviderBankDetails_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerBankDetails = _data["providerBankDetails"] ? GetInvestmentProviderBankDetails_Response_BankDetailsModel.fromJS(_data["providerBankDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvestmentProviderBankDetails_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestmentProviderBankDetails_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerBankDetails"] = this.providerBankDetails ? this.providerBankDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInvestmentProviderBankDetails_Response_Root {
    providerBankDetails?: GetInvestmentProviderBankDetails_Response_BankDetailsModel | undefined;
}

export class GetInvestmentProviderBankDetails_Response_BankDetailsModel implements IGetInvestmentProviderBankDetails_Response_BankDetailsModel {
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;

    constructor(data?: IGetInvestmentProviderBankDetails_Response_BankDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): GetInvestmentProviderBankDetails_Response_BankDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestmentProviderBankDetails_Response_BankDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["sortCode"] = this.sortCode;
        return data;
    }
}

export interface IGetInvestmentProviderBankDetails_Response_BankDetailsModel {
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;
}

export class GetJisaAccountOnboardingStage_Response_Root implements IGetJisaAccountOnboardingStage_Response_Root {
    stage?: PropelleAccountManagementCoreApplicationEnumsOnboardingStage;

    constructor(data?: IGetJisaAccountOnboardingStage_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): GetJisaAccountOnboardingStage_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetJisaAccountOnboardingStage_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        return data;
    }
}

export interface IGetJisaAccountOnboardingStage_Response_Root {
    stage?: PropelleAccountManagementCoreApplicationEnumsOnboardingStage;
}

export class GetJisaAccountOnboardingStage_Request_Root implements IGetJisaAccountOnboardingStage_Request_Root {

    constructor(data?: IGetJisaAccountOnboardingStage_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJisaAccountOnboardingStage_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetJisaAccountOnboardingStage_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJisaAccountOnboardingStage_Request_Root {
}

export class GetOnboardingStage_Response_Root implements IGetOnboardingStage_Response_Root {
    stage?: GetOnboardingStage_OnboardingStage;

    constructor(data?: IGetOnboardingStage_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): GetOnboardingStage_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnboardingStage_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        return data;
    }
}

export interface IGetOnboardingStage_Response_Root {
    stage?: GetOnboardingStage_OnboardingStage;
}

export enum GetOnboardingStage_OnboardingStage {
    NotStarted = "NotStarted",
    InitialDetails = "InitialDetails",
    PersonalDetails = "PersonalDetails",
    AccountSelection = "AccountSelection",
    KYCChecks = "KYCChecks",
    BankDetails = "BankDetails",
    Complete = "Complete",
}

export class GetOnboardingStageV2_Response_Root implements IGetOnboardingStageV2_Response_Root {
    stage?: GetOnboardingStageV2_OnboardingStage;

    constructor(data?: IGetOnboardingStageV2_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): GetOnboardingStageV2_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnboardingStageV2_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        return data;
    }
}

export interface IGetOnboardingStageV2_Response_Root {
    stage?: GetOnboardingStageV2_OnboardingStage;
}

export enum GetOnboardingStageV2_OnboardingStage {
    NotStarted = "NotStarted",
    Complete = "Complete",
}

export class GetOpenableAccountsForAccountHolder_Response_Root implements IGetOpenableAccountsForAccountHolder_Response_Root {
    accounts?: AccountType[] | undefined;
    hasIncompleteAccount?: boolean;
    incompleteAccountInfo?: GetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails | undefined;

    constructor(data?: IGetOpenableAccountsForAccountHolder_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            this.hasIncompleteAccount = _data["hasIncompleteAccount"];
            this.incompleteAccountInfo = _data["incompleteAccountInfo"] ? GetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails.fromJS(_data["incompleteAccountInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOpenableAccountsForAccountHolder_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenableAccountsForAccountHolder_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        data["hasIncompleteAccount"] = this.hasIncompleteAccount;
        data["incompleteAccountInfo"] = this.incompleteAccountInfo ? this.incompleteAccountInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOpenableAccountsForAccountHolder_Response_Root {
    accounts?: AccountType[] | undefined;
    hasIncompleteAccount?: boolean;
    incompleteAccountInfo?: GetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails | undefined;
}

export class GetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails implements IGetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails {
    accountType?: AccountType;
    stage?: PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStage;
    accountId?: string;
    lastUpdated?: Date;
    stageDescription?: string | undefined;

    constructor(data?: IGetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountType = _data["accountType"];
            this.stage = _data["stage"];
            this.accountId = _data["accountId"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.stageDescription = _data["stageDescription"];
        }
    }

    static fromJS(data: any): GetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        data["stage"] = this.stage;
        data["accountId"] = this.accountId;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["stageDescription"] = this.stageDescription;
        return data;
    }
}

export interface IGetOpenableAccountsForAccountHolder_Response_IncompleteAccountDetails {
    accountType?: AccountType;
    stage?: PropelleAccountManagementCoreApplicationEnumsAccountOnboardingStage;
    accountId?: string;
    lastUpdated?: Date;
    stageDescription?: string | undefined;
}

export class GetOpenableAccountsForAccountHolder_Request_Root implements IGetOpenableAccountsForAccountHolder_Request_Root {

    constructor(data?: IGetOpenableAccountsForAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOpenableAccountsForAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenableAccountsForAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOpenableAccountsForAccountHolder_Request_Root {
}

export class GetWealthKernelAccountSyncingHealth_Response implements IGetWealthKernelAccountSyncingHealth_Response {
    accounts?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse[];

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(GetWealthKernelAccountSyncingHealth_Response_AccountResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Response {
    accounts?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse[];
}

export class GetWealthKernelAccountSyncingHealth_Response_AccountResponse implements IGetWealthKernelAccountSyncingHealth_Response_AccountResponse {
    id?: string;
    accountType?: string | undefined;
    syncStages?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse[] | undefined;

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Response_AccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountType = _data["accountType"];
            if (Array.isArray(_data["syncStages"])) {
                this.syncStages = [] as any;
                for (let item of _data["syncStages"])
                    this.syncStages!.push(GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Response_AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Response_AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountType"] = this.accountType;
        if (Array.isArray(this.syncStages)) {
            data["syncStages"] = [];
            for (let item of this.syncStages)
                data["syncStages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Response_AccountResponse {
    id?: string;
    accountType?: string | undefined;
    syncStages?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse[] | undefined;
}

export class GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse implements IGetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse {
    order?: number;
    description?: string | undefined;
    status?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse_StatusResponse;

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse {
    order?: number;
    description?: string | undefined;
    status?: GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse_StatusResponse;
}

export enum GetWealthKernelAccountSyncingHealth_Response_AccountResponse_SyncStageResponse_StatusResponse {
    Complete = "Complete",
    Incomplete = "Incomplete",
    NotApplicable = "NotApplicable",
}

export class GetWealthKernelAccountSyncingHealth_Request implements IGetWealthKernelAccountSyncingHealth_Request {

    constructor(data?: IGetWealthKernelAccountSyncingHealth_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWealthKernelAccountSyncingHealth_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthKernelAccountSyncingHealth_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWealthKernelAccountSyncingHealth_Request {
}

export class MakeDeclaration_Request implements IMakeDeclaration_Request {

    constructor(data?: IMakeDeclaration_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MakeDeclaration_Request {
        data = typeof data === 'object' ? data : {};
        let result = new MakeDeclaration_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMakeDeclaration_Request {
}

export class MakeJisaDeclaration_Request implements IMakeJisaDeclaration_Request {

    constructor(data?: IMakeJisaDeclaration_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MakeJisaDeclaration_Request {
        data = typeof data === 'object' ? data : {};
        let result = new MakeJisaDeclaration_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMakeJisaDeclaration_Request {
}

export class SetUserOnboarding_Request_Root implements ISetUserOnboarding_Request_Root {
    hasCompletedOnboarding?: boolean;

    constructor(data?: ISetUserOnboarding_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCompletedOnboarding = _data["hasCompletedOnboarding"];
        }
    }

    static fromJS(data: any): SetUserOnboarding_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserOnboarding_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCompletedOnboarding"] = this.hasCompletedOnboarding;
        return data;
    }
}

export interface ISetUserOnboarding_Request_Root {
    hasCompletedOnboarding?: boolean;
}

export class UpdateAccountHolder_Request_Root implements IUpdateAccountHolder_Request_Root {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    nino?: string | undefined;
    currentAddress?: UpdateAccountHolder_Request_Address | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;

    constructor(data?: IUpdateAccountHolder_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.maidenName = _data["maidenName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.isUkTaxResident = _data["isUkTaxResident"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.nationality = _data["nationality"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.nino = _data["nino"];
            this.currentAddress = _data["currentAddress"] ? UpdateAccountHolder_Request_Address.fromJS(_data["currentAddress"]) : <any>undefined;
            this.employmentStatus = _data["employmentStatus"];
            this.industry = _data["industry"];
            if (Array.isArray(_data["sourcesOfWealth"])) {
                this.sourcesOfWealth = [] as any;
                for (let item of _data["sourcesOfWealth"])
                    this.sourcesOfWealth!.push(item);
            }
            this.annualIncome = _data["annualIncome"];
        }
    }

    static fromJS(data: any): UpdateAccountHolder_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountHolder_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["maidenName"] = this.maidenName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["isUkTaxResident"] = this.isUkTaxResident;
        data["isUsCitizen"] = this.isUsCitizen;
        data["nationality"] = this.nationality;
        data["countryOfBirth"] = this.countryOfBirth;
        data["nino"] = this.nino;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["employmentStatus"] = this.employmentStatus;
        data["industry"] = this.industry;
        if (Array.isArray(this.sourcesOfWealth)) {
            data["sourcesOfWealth"] = [];
            for (let item of this.sourcesOfWealth)
                data["sourcesOfWealth"].push(item);
        }
        data["annualIncome"] = this.annualIncome;
        return data;
    }
}

export interface IUpdateAccountHolder_Request_Root {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    maidenName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    isUkTaxResident?: boolean | undefined;
    isUsCitizen?: boolean | undefined;
    nationality?: string | undefined;
    countryOfBirth?: string | undefined;
    nino?: string | undefined;
    currentAddress?: UpdateAccountHolder_Request_Address | undefined;
    employmentStatus?: string | undefined;
    industry?: string | undefined;
    sourcesOfWealth?: string[] | undefined;
    annualIncome?: number | undefined;
}

export class UpdateAccountHolder_Request_Address implements IUpdateAccountHolder_Request_Address {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IUpdateAccountHolder_Request_Address) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.line3 = _data["line3"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UpdateAccountHolder_Request_Address {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountHolder_Request_Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["line3"] = this.line3;
        data["city"] = this.city;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IUpdateAccountHolder_Request_Address {
    line1?: string | undefined;
    line2?: string | undefined;
    line3?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    countryCode?: string | undefined;
}

export class PlaidExchangePlaidAuthPublicToken_Response implements IPlaidExchangePlaidAuthPublicToken_Response {
    error?: PlaidExchangePlaidAuthPublicToken_ErrorDetail | undefined;
    isSuccess?: boolean;

    constructor(data?: IPlaidExchangePlaidAuthPublicToken_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? PlaidExchangePlaidAuthPublicToken_ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): PlaidExchangePlaidAuthPublicToken_Response {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidExchangePlaidAuthPublicToken_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IPlaidExchangePlaidAuthPublicToken_Response {
    error?: PlaidExchangePlaidAuthPublicToken_ErrorDetail | undefined;
    isSuccess?: boolean;
}

export class PlaidExchangePlaidAuthPublicToken_ErrorDetail implements IPlaidExchangePlaidAuthPublicToken_ErrorDetail {
    type?: string;
    code?: string;
    message?: string;

    constructor(data?: IPlaidExchangePlaidAuthPublicToken_ErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PlaidExchangePlaidAuthPublicToken_ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidExchangePlaidAuthPublicToken_ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IPlaidExchangePlaidAuthPublicToken_ErrorDetail {
    type?: string;
    code?: string;
    message?: string;
}

export class PlaidExchangePlaidAuthPublicToken_Request implements IPlaidExchangePlaidAuthPublicToken_Request {
    publicToken?: string;

    constructor(data?: IPlaidExchangePlaidAuthPublicToken_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicToken = _data["publicToken"];
        }
    }

    static fromJS(data: any): PlaidExchangePlaidAuthPublicToken_Request {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidExchangePlaidAuthPublicToken_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicToken"] = this.publicToken;
        return data;
    }
}

export interface IPlaidExchangePlaidAuthPublicToken_Request {
    publicToken?: string;
}

export class PlaidGetPlaidAuthLinkToken_Response implements IPlaidGetPlaidAuthLinkToken_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    error?: PlaidGetPlaidAuthLinkToken_ErrorDetail | undefined;
    isSuccess?: boolean;

    constructor(data?: IPlaidGetPlaidAuthLinkToken_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkToken = _data["linkToken"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.error = _data["error"] ? PlaidGetPlaidAuthLinkToken_ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): PlaidGetPlaidAuthLinkToken_Response {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidGetPlaidAuthLinkToken_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkToken"] = this.linkToken;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IPlaidGetPlaidAuthLinkToken_Response {
    linkToken?: string | undefined;
    expiration?: Date | undefined;
    error?: PlaidGetPlaidAuthLinkToken_ErrorDetail | undefined;
    isSuccess?: boolean;
}

export class PlaidGetPlaidAuthLinkToken_ErrorDetail implements IPlaidGetPlaidAuthLinkToken_ErrorDetail {
    type?: string;
    code?: string;
    message?: string;

    constructor(data?: IPlaidGetPlaidAuthLinkToken_ErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PlaidGetPlaidAuthLinkToken_ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidGetPlaidAuthLinkToken_ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IPlaidGetPlaidAuthLinkToken_ErrorDetail {
    type?: string;
    code?: string;
    message?: string;
}

export class PlaidGetPlaidAuthLinkToken_Request implements IPlaidGetPlaidAuthLinkToken_Request {

    constructor(data?: IPlaidGetPlaidAuthLinkToken_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PlaidGetPlaidAuthLinkToken_Request {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidGetPlaidAuthLinkToken_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPlaidGetPlaidAuthLinkToken_Request {
}

export class PlaidVerifyPlaidLinkStatus_Response implements IPlaidVerifyPlaidLinkStatus_Response {
    hasToken?: boolean;
    error?: PlaidVerifyPlaidLinkStatus_ErrorDetail | undefined;
    isSuccess?: boolean;

    constructor(data?: IPlaidVerifyPlaidLinkStatus_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasToken = _data["hasToken"];
            this.error = _data["error"] ? PlaidVerifyPlaidLinkStatus_ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): PlaidVerifyPlaidLinkStatus_Response {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidVerifyPlaidLinkStatus_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasToken"] = this.hasToken;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IPlaidVerifyPlaidLinkStatus_Response {
    hasToken?: boolean;
    error?: PlaidVerifyPlaidLinkStatus_ErrorDetail | undefined;
    isSuccess?: boolean;
}

export class PlaidVerifyPlaidLinkStatus_ErrorDetail implements IPlaidVerifyPlaidLinkStatus_ErrorDetail {
    type?: string;
    code?: string;
    message?: string;

    constructor(data?: IPlaidVerifyPlaidLinkStatus_ErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PlaidVerifyPlaidLinkStatus_ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidVerifyPlaidLinkStatus_ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IPlaidVerifyPlaidLinkStatus_ErrorDetail {
    type?: string;
    code?: string;
    message?: string;
}

export class MobileGetAppUpdateRequired_Response_Root implements IMobileGetAppUpdateRequired_Response_Root {
    updateRequired?: MobileUpdateRequired;

    constructor(data?: IMobileGetAppUpdateRequired_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateRequired = _data["updateRequired"] ? MobileUpdateRequired.fromJS(_data["updateRequired"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileGetAppUpdateRequired_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new MobileGetAppUpdateRequired_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateRequired"] = this.updateRequired ? this.updateRequired.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMobileGetAppUpdateRequired_Response_Root {
    updateRequired?: MobileUpdateRequired;
}

export class MobileUpdateRequired implements IMobileUpdateRequired {
    forcedUpdate?: boolean;
    optionalUpdate?: boolean;

    constructor(data?: IMobileUpdateRequired) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forcedUpdate = _data["forcedUpdate"];
            this.optionalUpdate = _data["optionalUpdate"];
        }
    }

    static fromJS(data: any): MobileUpdateRequired {
        data = typeof data === 'object' ? data : {};
        let result = new MobileUpdateRequired();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forcedUpdate"] = this.forcedUpdate;
        data["optionalUpdate"] = this.optionalUpdate;
        return data;
    }
}

export interface IMobileUpdateRequired {
    forcedUpdate?: boolean;
    optionalUpdate?: boolean;
}

export class MobileGetAppUpdateRequired_Request_Root implements IMobileGetAppUpdateRequired_Request_Root {

    constructor(data?: IMobileGetAppUpdateRequired_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MobileGetAppUpdateRequired_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new MobileGetAppUpdateRequired_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMobileGetAppUpdateRequired_Request_Root {
}

export enum MobileGetAppUpdateRequired_Request_Platform {
    Android = "Android",
    Ios = "Ios",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}